import { createContext, useContext } from 'react'
import type { AuthUser } from '@/application/auth/api'

export type AuthState =
  | { status: 'loading' }
  | { status: 'anonymous' }
  | { status: 'authenticated'; user: AuthUser }

export type AuthContextValue = {
  state: AuthState
  setUser: (user: AuthUser) => void
  signOut: () => Promise<void>
  /** Re-checks /v1/me; called on mount + after a verify. */
  refresh: () => Promise<void>
}

export const AuthContext = createContext<AuthContextValue | null>(null)

export function useAuth(): AuthContextValue {
  const value = useContext(AuthContext)
  if (!value) {
    throw new Error('useAuth must be used inside <AuthProvider>')
  }
  return value
}
